<div *dxTemplate="let data of 'popupContent'">
  <div>
    <h3>
      {{ 'PROJECT_STEP.' + currentStep() | translate }}
    </h3>
    <form>
      <dx-form
        [(formData)]="project"
        [showValidationSummary]="true"
        validationGroup="projectData"
        id="form"
        (onFieldDataChanged)="validateStep()">
        @if (currentStep() === 'dateInput') {
          <dxi-item itemType="group">
            <dxi-item itemType="group" [colCount]="2">
              <dxo-label [text]="'PROJECT.FromDateTime' | translate"></dxo-label>
              <!-- Date Selection -->
              <dxi-item>
                <dx-date-box
                  [(value)]="fromDate!"
                  validationGroup="projectData"
                  type="date"
                  displayFormat="dd.MM.yyyy"
                  (onValueChanged)="updateFromDateTime()"
                  isRequired="true"
                  [inputAttr]="{ 'aria-label': 'From Date' }">
                  <dxi-validation-rule
                    type="required"
                    [message]="'PROJECT_VALIDATION.DATETIME_REQUIRED' | translate"></dxi-validation-rule>
                </dx-date-box>
              </dxi-item>
              <!-- Time Selection -->
              <dxi-item>
                <dx-date-box
                  [(value)]="fromTime!"
                  validationGroup="projectData"
                  type="time"
                  displayFormat="HH:mm"
                  (onValueChanged)="updateFromDateTime()"
                  isRequired="true"
                  [inputAttr]="{ 'aria-label': 'From Time' }">
                  <dxi-validation-rule
                    type="required"
                    [message]="'PROJECT_VALIDATION.DATETIME_REQUIRED' | translate"></dxi-validation-rule>
                </dx-date-box>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="2">
              <dxo-label [text]="'PROJECT.UntilDateTime' | translate"></dxo-label>
              <!-- Date Selection -->
              <dxi-item>
                <dx-date-box
                  [(value)]="untilDate!"
                  validationGroup="projectData"
                  type="date"
                  displayFormat="dd.MM.yyyy"
                  (onValueChanged)="updateUntilDateTime()"
                  isRequired="true"
                  [inputAttr]="{ 'aria-label': 'Until Date' }">
                  <dxi-validation-rule
                    type="required"
                    [message]="'PROJECT_VALIDATION.DATETIME_REQUIRED' | translate"></dxi-validation-rule>
                </dx-date-box>
              </dxi-item>
              <!-- Time Selection -->
              <dxi-item>
                <dx-date-box
                  [(value)]="untilTime!"
                  validationGroup="projectData"
                  type="time"
                  displayFormat="HH:mm"
                  (onValueChanged)="updateUntilDateTime()"
                  isRequired="true"
                  [inputAttr]="{ 'aria-label': 'Until Time' }">
                  <dxi-validation-rule
                    type="required"
                    [message]="'PROJECT_VALIDATION.DATETIME_REQUIRED' | translate"></dxi-validation-rule>
                </dx-date-box>
              </dxi-item>
            </dxi-item>
            <dxi-item editorType="dxDateRangeBox" [cssClass]="'hiddenInput'">
              <dxi-validation-rule
                name="dateRange"
                type="custom"
                [validationCallback]="validateDateRange"
                [message]="'PROJECT_VALIDATION.DATERANGE_IMPOSSIBLE' | translate"
                [reevaluate]="true"></dxi-validation-rule>
            </dxi-item>
          </dxi-item>
        }

        <dxi-item itemType="group" [visible]="currentStep() === 'vehicleSelection'">
          <dxi-item
            dataField="VehicleId"
            editorType="dxSelectBox"
            [editorOptions]="{
              dataSource: VehicleList,
              displayExpr: 'identifier',
              valueExpr: 'vehicleId',
              searchMode: 'contains',
              searchEnabled: true,
            }">
            <dxo-label [text]="'PROJECT.Vehicle' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>
      </dx-form>
    </form>

    <div class="errorMsg">{{ errorMessage }}</div>

    <div class="popup-nav">
      <dx-button
        [text]="'BUTTONS.BACK' | translate"
        (onClick)="previousStep()"
        [visible]="showBackButton"
        [hint]="actionButtonConfig.text | translate"></dx-button>
      <dx-button
        [text]="actionButtonConfig.text | translate"
        [visible]="actionButtonConfig.visible"
        [hint]="actionButtonConfig.text | translate"
        [useSubmitBehavior]="true"
        (onClick)="nextStep()"></dx-button>
    </div>
  </div>
</div>
